/**
 * Device detection utility to identify user's device type
 */

import {
  APP_STORE_URL_NC,
  APP_STORE_URL_NF,
  PLAY_STORE_URL_NC,
  PLAY_STORE_URL_NF,
} from "../functions/client";

export const detectDevice = (appName) => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const appStoreUrl =
    appName === "NextFriend" ? APP_STORE_URL_NF : APP_STORE_URL_NC;
  const playStoreUrl =
    appName === "NextFriend" ? PLAY_STORE_URL_NF : PLAY_STORE_URL_NC;

  // Check for iOS devices
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return {
      type: "ios",
      name: "iPhone/iPad",
      storeUrl: appStoreUrl, // Replace with your actual App Store URL
      storeName: "App Store",
    };
  }

  // Check for Android devices
  if (/android/i.test(userAgent)) {
    return {
      type: "android",
      name: "Android",
      storeUrl: playStoreUrl, // Replace with your actual Play Store URL
      storeName: "Google Play Store",
    };
  }

  // Default fallback for other devices (desktop, etc.)
  return {
    type: "other",
    name: "Desktop/Other",
    storeUrl: null,
    storeName: null,
  };
};

export const isMobileDevice = (appName) => {
  const device = detectDevice(appName);
  return device.type === "ios" || device.type === "android";
};
